<template>
  <div class="base">
    <account-header jump-user-type="teacher" />
    <div class="main">
      <div class="login-panel">
        <div>
          <div class="panno" />
        </div>
        <div class="title">
          家长登录
        </div>
        <a-form style="margin-top: 30px;" :form="form" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }"
          @submit="handleSubmit">
          <a-alert v-if="isLoginError" type="error" show-icon style="margin-bottom: 24px;"
            :message="loginErrorMessage" />
          <a-form-item>
            <a-input v-decorator="[
              'username',
              { rules: [{ required: true, message: '用户名不能为空' }] }
            ]" size="large" placeholder="用户名/手机号" />
          </a-form-item>
          <a-form-item>
            <a-input-password v-decorator="[
              'password',
              { rules: [{ required: true, message: '密码不能为空' }] }
            ]" size="large" placeholder="密码" />
          </a-form-item>
          <a-form-item v-if="false">
            <a-row :gutter="16">
              <a-col :span="16">
                <a-input v-decorator="[
                  'captcha_value',
                  { rules: [{ required: true, message: '请输入图形验证码' }] }
                ]" size="large" placeholder="图形验证码" />
              </a-col>
              <a-col :span="8">
                <img style="cursor: pointer" width="80px" height="100%" :src="captcha.img_str" alt=""
                  @click="loadVerify">
              </a-col>
            </a-row>
          </a-form-item>
          <div class="other-operations" style="overflow:hidden;margin-top:10%;">
            <div class="pull-left remmeber">
              <a-checkbox @change="onChange">
                记住密码
              </a-checkbox>
            </div>
            <div class="pull-right">
              <router-link style="margin-right:15px" :to="{ name: 'UserRegister' }">
                立即注册
              </router-link>
              <router-link :to="{ name: 'UserRetrievePass' }">
                忘记密码
              </router-link>
            </div>
          </div>
          <div class="now">
            <a-form-item>
              <a-button :loading="state.loginBtn" :disabled="state.loginBtn" size="large" type="primary"
                html-type="submit" block>
                登录
              </a-button>
            </a-form-item>
          </div>
        </a-form>
      </div>
    </div>
    <account-footer />
  </div>
</template>

<script>
import { AccountHeader, AccountFooter } from '@/components'
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'

export default {
  name: 'UserLogin',
  description: '这是描述信息',
  components: {
    AccountHeader,
    AccountFooter
  },
  data() {
    return {
      id: 1,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      captcha_key: '',
      captcha_value: '',
      captcha: {
        img_str: ''
      },
      // captcha_img_str: '',
      isLoginError: false,
      loginErrorMessage: '账户或密码错误',
      state: {
        loginBtn: false
      }
    }
  },
  created() {
    this.loadVerify()
  },
  methods: {
    ...mapActions(['UserLogin']),
    loadVerify() {
      // 调用删除
      this.$http({
        url: '/index/index/captcha',
        method: 'get'
      }).then(res => {
        console.log(res)
        if (res.status === 'success') {
          this.captcha_key = res.data.captcha_key
          this.captcha_value = res.data.captcha_value
          // this.captcha_img_str = res.data.img_str
          this.$set(this.captcha, 'img_str', res.data.img_str)
        } else {
          this.$notification.error({
            message: '错误',
            description: '获取验证码失败'
          })
        }
      })
    },
    onChange(e) {
      console.log(`checked = ${e.target.checked}`)
    },
    // 提交
    handleSubmit(e) {
      e.preventDefault()
      const { form, state, UserLogin } = this
      const that = this
      this.isLoginError = false
      form.validateFields((err, values) => {
        if (!err) {
          this.state.loginBtn = true
          console.log('Received values of form: ', values)
          values.captcha_key = that.captcha_key
          values.captcha_value = that.captcha_value
          UserLogin(values)
            .then(res => this.loginSuccess(res))
            .catch(err => this.requestFailed(err))
            .finally(() => {
              state.loginBtn = false
              that.loadVerify()
            })
        }
      })
    },
    loginSuccess() {
      this.$router.push({ name: 'Index' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.toast(`${timeFix()}，欢迎回来`)
      }, 1000)
      this.isLoginError = false
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorMessage =
        (err || {} || {}).message || '请求出现错误，请稍后再试'
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;

  .login-panel {
    background-color: #ffffff;
    box-shadow: 1px 3px 16px 0px rgba(34, 23, 20, 0.1);
    border-radius: 10px;
    padding: 15px;
    overflow: hidden;
    margin-top: 15%;

    .panno {
      width: 75px;
      height: 10px;
      background-color: #fa750d;
      border-radius: 9px;
      position:relative;
      top:-18px;
      margin:auto;
    }

    .title {
      text-align:center;
      margin-top:8%;
      font-family: PingFang-SC-Bold;
      font-size: 18px;
      line-height: 21px;
      color: #333333;
      font-weight: bold;
    }

    .phone {
      margin-top: 30px;
    }

    .password {
      margin-top: 20px;
    }

    .other-operations {
      .pull-right {
        a {
          height: 14px;
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 14px;
          color: #666666;
        }
      }
    }

    .now {
      margin-top: 68px;

      button {
        width: 100%;
        height: 40px;
        background-color: #ff5c00;
        border-radius: 10px;
      }
    }
  }
}
</style>
